module.exports = __webpack_public_path__ + "left_handle.png";